import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ModalForm } from 'shared/common/components/ModalForm';
import { useAppDispatch } from 'shared/common/hooks';
import { selectModalStatus } from 'shared/common/selectors/modalStatus';
import { setFormStatus, setModalStatus } from 'shared/common/slices';
import { EModalStatus } from 'shared/common/types/modal';
import { FormContainer as SellerFormContainer } from '../../../landingSeller/containers/FormContainer';
import { selectFormStatus } from 'shared/common/selectors/form';
import { EFormStatus } from 'shared/common/types/form';
import { ModalStatusForm } from 'shared/common/components/ModalStatusForm';
import { EPageName } from '../../constants/pages';
import { FormContainer as BuyerFormContainer } from '../../../landingBuyer/containers/FormContainer';

interface IModalFormContainerProps {
  modalPageType: EPageName;
}

export const ModalFormContainer: FC<IModalFormContainerProps> = ({ modalPageType }) => {
  const dispatch = useAppDispatch();
  const isSellerLanding = modalPageType === EPageName.LandingSeller;
  const FormContainer = isSellerLanding ? SellerFormContainer : BuyerFormContainer;

  const modalStatus = useSelector(selectModalStatus);

  const formStatus = useSelector(selectFormStatus);

  const handleModalClose = useCallback(() => {
    if (formStatus !== EFormStatus.Init) {
      dispatch(setFormStatus(EFormStatus.Init));
    }

    dispatch(setModalStatus(EModalStatus.Hide));
  }, [dispatch, formStatus]);

  const isOpen = modalStatus === EModalStatus.Open;

  const returnedContent = () => {
    if (formStatus === EFormStatus.Success) {
      return (
        <ModalStatusForm
          onClick={handleModalClose}
          description="С&nbsp;9&nbsp;до&nbsp;21&nbsp;по&nbsp;мск&nbsp;менеджер позвонит вам, чтобы&nbsp;обсудить детали"
          title="Скоро перезвоним"
        />
      );
    }

    if (formStatus === EFormStatus.Failed) {
      return <ModalStatusForm onClick={handleModalClose} description="Попробуйте позже" title="Что-то пошло не так" />;
    }

    return <FormContainer theme="black" isModalForm />;
  };

  return (
    <ModalForm onCloseModal={handleModalClose} isOpen={isOpen} form={returnedContent()} modalPageType={modalPageType} />
  );
};
